export namespace Roles {
  export const Permission = {
    Create: 'create',
    ViewAll: 'view_all',
    ViewLimited: 'view_limited',
    Update: 'update',
    Delete: 'delete',
    Manage: 'manage',
    None: 'none',
  } as const

  export type Permission = (typeof Permission)[keyof typeof Permission]

  export const PermissionScope = {
    All: 'all',
    Own: 'own',
    None: 'none',
  } as const

  export type PermissionScope = (typeof PermissionScope)[keyof typeof PermissionScope]

  export const ResourceType = {
    Organizations: 'organizations',
    Workspaces: 'workspaces',
    Goals: 'goals',
    Groups: 'groups',
    Billing: 'billing',
    Members: 'members',
    Roles: 'roles',
    Flags: 'flags',
    Channels: 'channels',
    Impersonation: 'impersonation',
    InteractionsViewAll: 'interactions_view_all',
    InteractionsViewHandled: 'interactions_view_handled',
    InteractionsManage: 'interactions_manage',
    InteractionsExport: 'interactions_export',
    EvaluationsViewAll: 'evaluations_view_all',
    EvaluationsViewAssigned: 'evaluations_view_assigned',
    EvaluationsSubmitted: 'evaluations_submitted',
    Knowledge: 'knowledge',
    Scorecards: 'scorecards',
    Evaluate: 'evaluate',
    Comments: 'comments',
    Leaderboard: 'leaderboard',
  } as const

  export type ResourceType = (typeof ResourceType)[keyof typeof ResourceType]
}
